import type { ComponentProps } from "react";
import { readyLazy } from "../../lib/ready-lazy";
import type { AbilityReference as AbilityReferenceElement } from "../ability-reference";
import type {
  LiveMatchup as LiveMatchupElement,
  LiveMatchupControl as LiveMatchupControlElement,
} from "../live-matchup";
import { addLazyParts } from "../../lib/page-readiness";
import { LeagueBlockView, LeagueHandbook, LeagueSection, RichText } from "./lazy-league";

// The site's League widgets (website-page-nodes.tsx), which read through its server functions, so
// unlike ./lazy-league.ts they never reach the editor's canvas. They load the same way, and the
// root route imports this module, so they join lib/page-readiness.ts before any page loads.
export const AbilityReference = readyLazy<ComponentProps<typeof AbilityReferenceElement>>(() =>
  import("../ability-reference").then((module) => ({ default: module.AbilityReference })),
);
export const LiveMatchup = readyLazy<ComponentProps<typeof LiveMatchupElement>>(() =>
  import("../live-matchup").then((module) => ({ default: module.LiveMatchup })),
);
export const LiveMatchupControl = readyLazy<ComponentProps<typeof LiveMatchupControlElement>>(() =>
  import("../live-matchup").then((module) => ({ default: module.LiveMatchupControl })),
);

addLazyParts((node) => {
  if (node.kind === "abilityReference") return AbilityReference;
  if (node.kind === "liveMatchup") return LiveMatchup;
  return node.kind === "liveMatchupControl" ? LiveMatchupControl : undefined;
});

/** Loads every League element, for a League site whose next pages will show them. */
export async function readyLeagueParts(): Promise<void> {
  const parts = [RichText, LeagueHandbook, LeagueSection, LeagueBlockView, AbilityReference];
  await Promise.all([...parts, LiveMatchup, LiveMatchupControl].map((part) => part.ready()));
}
